import React from 'react';
import Tooltip from '@Components/Tooltip';
import { getAccessibleElementSearcher } from './utils';
import useSetElementAccessible from './useSetElementAccessible';
/* eslint-disable react-hooks/exhaustive-deps */
export default function useAccessibleHoverTooltip(tooltip, isTooltipElementAccessible = false) {
  const [accessible, setAccessible] = React.useState(null);

  const handleFocus = React.useCallback(() => {
    if (!tooltip) {
      return;
    }

    Tooltip.show(tooltip);
  }, [tooltip]);
  const handleBlur = React.useCallback(() => {
    if (!tooltip) {
      return;
    }

    Tooltip.hide(tooltip);
  }, [tooltip]);

  useSetElementAccessible(accessible, {
    onFocus: handleFocus,
    onBlur: handleBlur,
  });

  React.useEffect(() => {
    if (tooltip) {
      // on SVG can't read attributes and find focusable correctly - take tooltip trigger element itself
      if (isTooltipElementAccessible) {
        setAccessible(tooltip);
      } else {
        // in other cases find first accessible element inside
        const searcher = getAccessibleElementSearcher(setAccessible);

        searcher(tooltip);
      }
    }
  }, [tooltip]);
}
